import React from 'react'
import { Box, Text, Stack } from '@chakra-ui/react'
import { CURRENT } from './types'

export interface TransferDetailsPreviewProps {
  contributionType?: string
  contributionYear?: string
}

const ModalContributionDetailsPreview = ({ contributionType, contributionYear }: TransferDetailsPreviewProps) => {
  return (
    <Stack spacing={2}>
      <Text as='h3' textStyle='h3'>
        Contribution Details
      </Text>
      <Stack spacing={4}>
        <Stack direction='row' w='100%' spacing={4}>
          <Box w='50%' data-testid='modalContributionType'>
            <Text fontWeight='bold'>Contribution Type</Text>
            <Text>{contributionType}</Text>
          </Box>
        </Stack>
        <Stack direction='row' w='100%' spacing={4}>
          <Box w='50%' data-testid='modalContributionYear'>
            <Text fontWeight='bold'>Contribution Year</Text>
            <Text>{contributionYear && contributionYear !== CURRENT ? 'Previous Year' : 'Current Year'}</Text>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default ModalContributionDetailsPreview
